/**
 * Created by joerg on 13.06.17.
 */
import React, {Component} from 'react';
import BaseDataEntry from './BaseDataEntry'
import GebaudeSrukturEntry from './GebaudeSrukturEntry'
import DetailDataEntry from './DetailDataEntry'
import Kostenanalyse from './Kostenanalyse'
import KostenanalyseBrespa from './KostenanalyseBrespa'
import KostenanalyseHF from './KostenanalyseHF'
import KostenanalyseOrtbeton from './KostenanalyseOrtbeton'
import KurzergebnisHor from './KurzergebnisHor'
import {inject} from 'mobx-react';

@inject('baseDataStore')
@inject('brespaAnalyseStore')
@inject('ortbetonAnalyseStore')
@inject('halbfertigAnalyseStore')
class BrespaEntries extends Component {
    _makesticky(){
        window.jQuery('.sticky').width(window.jQuery('.container').outerWidth());
        window.jQuery('.below').css("margin-top",window.jQuery('.sticky').outerHeight()+20);
    }
    componentDidMount(){
        let self = this;
        window.jQuery(window).scroll(function(){
            self._makesticky();
        });
        window.jQuery(window).resize(function(){
            self._makesticky();
        });
        self._makesticky();
    }

    render() {
        return (
            <div>
                <div className="row sticky" style={{position:"fixed",zIndex:1000,top:50,backgroundColor:"#ffffff"}} >


                    <div className="col-md-12 col-lg-12 col-sm-12">
                        <KurzergebnisHor baseDataStore={this.props.baseDataStore} brespaAnalyseStore={this.props.brespaAnalyseStore}
                                      ortbetonAnalyseStore={this.props.ortbetonAnalyseStore} halbfertigAnalyseStore={this.props.halbfertigAnalyseStore}/>
                    </div>
                </div>
                <div className="row below" >

                    <div className="col-md-4 col-lg-4 col-sm-12">
                        <KostenanalyseBrespa dataStore={this.props.brespaAnalyseStore} baseDataStore={this.props.baseDataStore}/>
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12">
                        <KostenanalyseHF dataStore={this.props.halbfertigAnalyseStore} baseDataStore={this.props.baseDataStore}/>

                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12">
                        <KostenanalyseOrtbeton dataStore={this.props.ortbetonAnalyseStore} baseDataStore={this.props.baseDataStore}/>
                        {/*<DetailDataEntry baseDataStore={this.props.baseDataStore}/>*/}
                    </div>

                </div>
                <div className="row " >
                    <div className="col-md-4 col-lg-4 col-sm-12">
                        {/*<KostenanalyseBrespa dataStore={this.props.brespaAnalyseStore}/>*/}
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12">
                        {/*<KostenanalyseHF dataStore={this.props.halbfertigAnalyseStore}/>*/}
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12">

                    </div>
                </div>

            </div>

        )
    }
}

export default BrespaEntries


// WEBPACK FOOTER //
// ./src/components/BrespaEntries.js